import React, { useMemo, useContext } from "react";
import Card from "./Card";

//importing data
import data from "../data/data.json";

import { SavedContext } from "../App";

const Random = (props) => {
  const { saved } = useContext(SavedContext);
  const random = useMemo(() => props.results[props.random], [props.results, props.random]);
  return (
    <div>
      <div>
        {props.results[0] ? (
          random ? (
            <Card
              addSave={props.addSave}
              removeSave={props.removeSave}
              question={random.text}
              date={random.date}
              saveid={random.saveid}
              answer={random.answer}
              value={random.value}
              topic={random.topic}
              answermedia={random.answermedia}
              textmedia={random.textmedia}
              variant={"border bold"}
              saved={saved.includes(random.saveid)}
            />
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Random;
